import {
  ContainerMessage,
  IconInsideInput,
} from 'components/InputField/style/input.style';
import styled from 'styled-components';
import colors from '../style-utils/colors';

export interface FormGroupProps {
  isError?: boolean;
  isAlert?: boolean;
}

export const LabelInput = styled.label`
  color: var(--field-label);
  font-weight: 300;
  position: absolute;
  pointer-events: none;
  background-color: inherit;
  top: 10px;
  left: 13px;
  line-height: 1.72;
  font-size: 14px;
  letter-spacing: -0.13px;
  transition: 0.2s ease all;
`;

const computeDataShrinkValue = (
  value: string | number | string[] | undefined,
) => {
  if (
    typeof value === 'undefined' ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return undefined;
  }
  return '1';
};

export const FormGroup = styled.div<FormGroupProps>`
  position: relative;
  height: 44px;

  color: var(--field-text);

  & + ${ContainerMessage} {
    font-size: 12px;
    line-height: 14px;
  }

  ${({ isError, isAlert }) => {
    if (isAlert) {
      return `
        color: var(--field-warning);

        & > ${LabelInput},
        & + ${ContainerMessage} {
          color: var(--field-warning)!important;
        }

        /* '& > Input:focus' is there only to fix specificity issues. */

        & > ${Input},
        & > ${Input}:focus {
            border-color: var(--field-warning);
            background: var(--field-error-background);
        }

        & > ${IconInsideInput} {
          display: block;
        }

      `;
    }
    if (isError) {
      return `
        color:  var(--field-error);

        & > ${LabelInput},
        & + ${ContainerMessage} {
          color:  var(--field-error)!important;
        }

        /* '& > Input:focus' is there only to fix specificity issues. */

        & > ${Input},
        & > ${Input}:focus {
          border-color:var(--field-error);
          background:var(--field-error-background);
        }

        & > ${IconInsideInput} {
          display: block;
        }
      `;
    }
  }};
`;

export const Input = styled.input.attrs(
  ({ value }: { value: string | number | string[] | undefined }) => ({
    'data-shrink': computeDataShrinkValue(value),
  }),
)`
  color: var(--field-text);
  border-radius: 4px;
  height: 44px;
  padding: 9px 13px;
  display: block;
  width: 100%;
  border: var(--field-border-width) solid var(--field-border);
  font-weight: 400;
  line-height: 1.857;
  font-size: 16px;
  background: var(--field-background);
  box-shadow: none;

  /* Remove box-shadow inside input */

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Hides the credentials indicator in safari. */
  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--field-border-focus);
  }

  &:focus ~ ${LabelInput}, &[data-shrink='1'] ~ ${LabelInput} {
    top: -10px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 500;
    background: ${colors.white};
  }

  &[data-shrink='1'] ~ ${LabelInput} {
    color: var(--label-floating);
  }

  &:focus ~ ${LabelInput} {
    color: var(--field-border-focus);
  }

  &::placeholder {
    font-size: 16px;
    font-weight: normal;
    color: var(--placeholder-color, #a9a9a9);
  }
  &:disabled {
    background-color: #f2f2f2;
    border: var(--field-border-width) solid var(--field-border);
    color: var(--field-border);
  }
`;

export const InputArea = styled.textarea.attrs(
  ({ value }: { value: string | number | string[] | undefined }) => ({
    'data-shrink': computeDataShrinkValue(value),
  }),
)`
  color: var(--field-text);
  border-radius: 4px;
  height: 70px;
  padding: 9px 13px;
  display: block;
  width: 100%;
  border: var(--field-border-width) solid var(--field-border);
  font-weight: normal;
  line-height: 1.857;
  font-size: 14px;
  background: var(--field-background);
  box-shadow: none;
  resize: both;
  overflow: auto;
  margin-top: 6px;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::placeholder {
    font-size: 14px;
    font-weight: normal;
    color: var(--placeholder-color, #a9a9a9);
  }

  &::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--field-border-focus);
  }

  &:focus ~ ${LabelInput}, &[data-shrink='1'] ~ ${LabelInput} {
    top: -10px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 500;
    background: ${colors.white};
  }

  &[data-shrink='1'] ~ ${LabelInput} {
    color: var(--label-floating);
  }

  &:focus ~ ${LabelInput} {
    color: var(--field-border-focus);
  }
`;
